const UPDATE_NEW_CUE_POINT = 'UPDATE_NEW_CUE_POINT';
const UPDATE_SAVED_CUE_POINTS = 'UPDATE_SAVED_CUE_POINTS';
const LOADING = 'LOADING';
const LOADING_FAILED = 'LOADING_FAILED';
const SAVING = 'SAVING';
const SAVE_SUCCESS = 'SAVE_SUCCESS';
const SET_ERROR = 'SET_ERROR';
const SET_ERRORS = 'SET_ERRORS';
const DISMISS_ERROR_MODAL = 'DISMISS_ERROR_MODAL';
const SET_PODCAST_EPISODE_ID = 'SET_PODCAST_EPISODE_ID';
const REMOVING = 'REMOVING';
const REMOVE_SUCCESS = 'REMOVE_SUCCESS';
const REMOVE_FAILED = 'REMOVE_FAILED';
const CLEAR_ERROR = 'CLEAR_ERROR';

enum STATUS {
  IDLE,
  IS_SAVING,
  IS_LOADING,
  SUCCESS,
  ERROR,
  LOADING_ERROR,
}

const DURATION_ERROR_MESSAGE =
  'One or more of your ad slots has been disabled. Timestamps must be less than the episode length.';

export {
  STATUS,
  UPDATE_NEW_CUE_POINT,
  UPDATE_SAVED_CUE_POINTS,
  LOADING,
  LOADING_FAILED,
  SAVING,
  SAVE_SUCCESS,
  SET_ERROR,
  SET_ERRORS,
  DISMISS_ERROR_MODAL,
  SET_PODCAST_EPISODE_ID,
  REMOVING,
  REMOVE_SUCCESS,
  REMOVE_FAILED,
  CLEAR_ERROR,
  DURATION_ERROR_MESSAGE,
};
